export const menuItems = [
  {
    name: 'Überblick',
    path: '/ueberblick'
  },
  {
    name: 'Postfach',
    path: '/postfach'
  },
  {
    name: 'Verträge',
    path: '/vertraege'
  },
  {
    name: 'Schäden',
    path: '/schaeden'
  },
  {
    name: 'Einstellungen',
    path: '/einstellungen'
  },
  {
    name: 'Persönliche Daten',
    path: '/persoenliche-daten'
  },
  {
    name: 'Vertragsservice',
    path: window.ENV_CONFIG.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.ROOT
  }
]
